import { Affix } from '@warp-ds/react';
import { TextField } from '@warp-ds/react/components/textfield';
import type { Ref } from 'react';
import type { PrepackageDestination } from '../../types';
import { getDestinationSummary } from './labels';

type DestinationPickerTriggerProps = {
    inputRef: Ref<HTMLInputElement>;
    isMobile: boolean;
    isOpen: boolean;
    searchQuery: string;
    selectedDestinations: PrepackageDestination[];
    onOpen: () => void;
    onSearchQueryChange: (query: string) => void;
    onReset: () => void;
};

export const DestinationPickerTrigger = ({
    inputRef,
    isMobile,
    isOpen,
    searchQuery,
    selectedDestinations,
    onOpen,
    onSearchQueryChange,
    onReset,
}: DestinationPickerTriggerProps) => {
    const selectedSummary = getDestinationSummary(selectedDestinations);
    const value = isMobile ? selectedSummary : isOpen ? searchQuery : selectedSummary;

    const clear = () => {
        onReset();
        onSearchQueryChange('');
    };

    return (
        <TextField
            ref={inputRef}
            id="destination"
            label={isMobile ? '' : 'Til'}
            placeholder={'Velg reisemål...'}
            value={value}
            type={'text'}
            inputMode={isMobile ? 'none' : undefined}
            autoComplete="off"
            aria-haspopup={isMobile ? 'dialog' : undefined}
            aria-expanded={isOpen}
            aria-controls="prepackage-destination-popover"
            onFocus={isMobile ? undefined : onOpen}
            onClick={onOpen}
            onChange={(event) => {
                if (isMobile) return;

                onSearchQueryChange(event.target.value);
                if (!isOpen) onOpen();
            }}>
            {value.length > 0 && <Affix suffix clear aria-label="Nullstill" onClick={clear} />}
        </TextField>
    );
};
